import { render, staticRenderFns } from "./AchievementsDetail.vue?vue&type=template&id=e93a8286&scoped=true"
import script from "./AchievementsDetail.vue?vue&type=script&lang=ts"
export * from "./AchievementsDetail.vue?vue&type=script&lang=ts"
import style0 from "./AchievementsDetail.vue?vue&type=style&index=0&id=e93a8286&lang=scss"
import style1 from "./AchievementsDetail.vue?vue&type=style&index=1&id=e93a8286&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93a8286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\sandy\\Desktop\\EIOSYS\\Admin\\Alembic-Grow-Admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e93a8286')) {
      api.createRecord('e93a8286', component.options)
    } else {
      api.reload('e93a8286', component.options)
    }
    module.hot.accept("./AchievementsDetail.vue?vue&type=template&id=e93a8286&scoped=true", function () {
      api.rerender('e93a8286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/achievements/components/AchievementsDetail.vue"
export default component.exports